module.exports = __webpack_public_path__ + "static/img/logo.521d9d1b.svg";